// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';

export default class ActiveFilterCounter extends Component {
  /**
   * Initialize the component.
   */
  bind(el: HTMLElement): void {
    super.bind(el);
    this.addListener(Notifications.FILTERED, this.onFiltered);
    this.onFiltered();
  }

  /**
   * Executes when the user has filtered.
   */
  onFiltered(): void {
    const count: number = this.getFilterCount();
    if (count) {
      this.el.innerHTML = `(${count})`;
    } else {
      this.el.innerHTML = '';
    }
  }

  /**
   * Get the current count of the active filters
   */
  getFilterCount(): number {
    return window.store.url.activeFilters().count();
  }
}
